import { InvoiceStatus as InvoiceStatusEnum } from "@common/types/invoice";
import {
    StatusIndicator,
    StatusIndicatorVariant,
} from "@design-system/StatusIndicator/StatusIndicator";
import { getInvoiceStatusLabel } from "./getInvoiceStatusLabel";

const STATUS_VARIANTS: Record<InvoiceStatusEnum, StatusIndicatorVariant> = {
    [InvoiceStatusEnum.DRAFT]: "gray",
    [InvoiceStatusEnum.OPEN]: "yellow",
    [InvoiceStatusEnum.PAID]: "blue",
    [InvoiceStatusEnum.VOID]: "purple",
    [InvoiceStatusEnum.UNCOLLECTABLE]: "red",
};

interface InvoiceStatusProps {
    status: InvoiceStatusEnum;
    className?: string;
    showText?: boolean;
    label?: string;
    textClassName?: string;
}

export const InvoiceStatus: React.FC<InvoiceStatusProps> = ({
    status,
    className,
    showText = false,
    label,
    textClassName,
}) => (
    <StatusIndicator
        variant={STATUS_VARIANTS[status]}
        label={label ?? getInvoiceStatusLabel(status)}
        showText={showText}
        className={className}
        textClassName={textClassName}
    />
);
